import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'

import {
  useDuplicateCaseMutation,
  useLazyGetRecipesQuery,
} from '@/store/apiService'
import { clearSelectedCases } from '@/store/project'

export const useDuplicateCase = () => {
  const [duplicateCase] = useDuplicateCaseMutation()
  const [triggerPoll] = useLazyGetRecipesQuery()
  const dispatch = useDispatch()
  const { t } = useTranslation('translation', {
    keyPrefix: 'projectsTable.toast',
  })

  const duplicate = async ({
    ids,
    refetch,
    shared = false,
    onComplete,
  }: {
    ids: string[]
    refetch?: () => void
    shared?: boolean
    onComplete?: () => void
  }) => {
    try {
      await duplicateCase({ ids }).unwrap()
      toast.info(t('duplicateInProcess'))
      dispatch(clearSelectedCases())

      setTimeout(() => {
        const queryArgs = {
          duplication_status: 'in_progress',
          paginated: false,
          shared,
        }

        const interval = setInterval(async () => {
          try {
            const result = await triggerPoll(queryArgs).unwrap()
            const inProgressList = result || []

            if (inProgressList.length === 0) {
              clearInterval(interval)
              refetch?.()
              toast.success(t('duplicateSuccess'))
              onComplete?.()
            }
          } catch (err) {
            clearInterval(interval)
            toast.error(t('duplicateStatusError'))
          }
        }, 2000)
      }, 1000)
    } catch (err) {
      toast.error(t('duplicateFailed'))
    }
  }

  return { duplicate }
}
